import { useState } from 'react';
import { Row, Col, Card, Skeleton, Segmented } from 'antd';
import { DollarOutlined, FallOutlined, RiseOutlined } from '@ant-design/icons';
import './financial-dashboard.css';

const fmt = (value, currency = 'MXN') =>
  new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(value || 0);

function IndicatorCard({ title, icon, color, mxn, usd }) {
  return (
    <div className="fi-card" style={{ borderTopColor: color }}>
      <div className="fi-card-header">
        <span className="fi-card-icon" style={{ color }}>{icon}</span>
        <span className="fi-card-title">{title}</span>
      </div>
      <div className="fi-card-row">
        <div className="fi-currency-block">
          <span className="fi-currency-label">MXN</span>
          <span className="fi-currency-value" style={{ color }}>{fmt(mxn, 'MXN')}</span>
        </div>
        <div className="fi-divider" />
        <div className="fi-currency-block">
          <span className="fi-currency-label">USD</span>
          <span className="fi-currency-value fi-usd">{fmt(usd, 'USD')}</span>
        </div>
      </div>
    </div>
  );
}

const PERSONA_OPTIONS = [
  { label: 'Total', value: 'total' },
  { label: 'Persona Moral', value: 'moral' },
  { label: 'Persona Física', value: 'fisica' },
];

export default function FinancialIndicators({ data = {}, loading, currentDateInfo }) {
  const [persona, setPersona] = useState('total');

  const ventas   = data.ventas     || {};
  const gastos   = data.gastos     || {};
  const utilidades = data.utilidades || {};

  const ventasMXN = ventas.MXN?.total || 0;
  const ventasUSD = ventas.USD?.total || 0;

  let gastosMXN, gastosUSD;

  if (persona === 'total') {
    gastosMXN = gastos.total?.MXN || 0;
    gastosUSD = gastos.total?.USD || 0;
  } else {
    gastosMXN = gastos[persona]?.MXN?.total || 0;
    gastosUSD = gastos[persona]?.USD?.total || 0;
  }

  const utilidadMXN = persona === 'total'
    ? (utilidades.MXN?.utilidad || 0)
    : ventasMXN - gastosMXN;

  const utilidadUSD = persona === 'total'
    ? (utilidades.USD?.utilidad || 0)
    : ventasUSD - gastosUSD;

  const cards = [
    {
      title: 'Ventas',
      icon: <DollarOutlined />,
      color: '#52c41a',
      mxn: ventasMXN,
      usd: ventasUSD,
    },
    {
      title: 'Gastos',
      icon: <FallOutlined />,
      color: '#f5222d',
      mxn: gastosMXN,
      usd: gastosUSD,
    },
    {
      title: 'Utilidades',
      icon: <RiseOutlined />,
      color: '#1890ff',
      mxn: utilidadMXN,
      usd: utilidadUSD,
    },
  ];

  return (
    <Card
      className="financial-card"
      bodyStyle={{ padding: '16px' }}
      extra={
        <Segmented
          size="small"
          options={PERSONA_OPTIONS}
          value={persona}
          onChange={setPersona}
        />
      }
    >
      <Skeleton loading={loading} active paragraph={{ rows: 2 }}>
        <Row gutter={[16, 16]}>
          {cards.map((card) => (
            <Col key={card.title} xs={24} sm={8}>
              <IndicatorCard {...card} />
            </Col>
          ))}
        </Row>
      </Skeleton>
    </Card>
  );
}
